// breadcrumbsModule
window.breadcrumbsModule = (() => {
  if (!customElements.get("menu-drawer-tabs")) {
    class MenuDrawerTabsComponent extends HTMLElement {
      connectedCallback() {
        this.handleTabsClick();
      }

      handleTabsClick() {
        const tabs = this.querySelectorAll(".drawer-menu__tab:not(.menu-drawer-close-icon)");
        const tabContents = document.querySelectorAll("header-drawer .tab-content");
        tabs.forEach((tab, index) => {
          tab.addEventListener("click", () => {
            tabs.forEach((t) => t.classList.remove("active"));
            tab.classList.add("active");
            tabContents.forEach((t) => {
              t.classList.remove("tab-content-active");
            });
            tabContents[index].classList.add("tab-content-active");
          });
        });
      }
    }

    customElements.define("menu-drawer-tabs", MenuDrawerTabsComponent);
  }

  // Public API
  return {
    MenuDrawerTabsComponent: customElements.get("menu-drawer-tabs"),
  };
})();
